<template>
    <div>
        <h3>お試し登録</h3>
        <div>
            <p>
                貸し本棚はメールアドレスもパスワードも何も無しにお試し登録することができます。
                お試し登録すると、小説執筆エディタやファイルインポート、ノートなどの基本的な機能をお試し頂けます。
            </p>
            <p>
                お試し登録で投稿した小説は仮公開できますが、お試しアカウントが消滅した場合、
                それに伴って削除されます。仮公開した小説のURLをどこかに貼らないようにしてください。
                仮公開作品を正式公開したい場合、正式登録を行ってください。
            </p>
            <h4>お試し登録の方法</h4>
            <img src="/img/help/account/04.png" alt="お試し登録" class="img-thumbnail mb-3">
            <p>
                <a href="/guest">お試し登録</a>ページから、お試し登録を行ってください。
                名前は必須ではありません。何も入力しないと「お試しさん」という名前になります。
            </p>
            <h4>お試し登録でできること</h4>
            <p>
                お試し登録でできることは限られていますが、基本的な機能は使ってみることができます。
            </p>
            <ul class="list-group">
                <li class="list-group-item"><b>小説の登録と執筆</b>…登録画面とエピソードエディタをお試し頂けます。</li>
                <li class="list-group-item"><b>公開設定</b>…複数エピソードの一括公開設定をお試し頂けます。</li>
                <li class="list-group-item"><b>仮公開</b>…お試し登録で追加した小説は「非公開」という状態になります。このまま公開すると「URLを知っている人だけが見える」公開ページが作成されます。</li>
                <li class="list-group-item"><b>ノート</b>…梗概や登場人物設定などを記載するノートの機能をお試し頂けます。</li>
                <li class="list-group-item"><b>作品インポート</b>…小説家になろうやカクヨム形式のバックアップファイルを直接インポートできます。</li>
            </ul>
            <p>
                これ以外に履歴やお気に入り、感想の確認やフォロー機能なども開放されていますが、
                これらは正規登録の後にご利用頂くことをお勧めします。
            </p>
            <h4>正規登録</h4>
            <p>
                貸し本棚の機能を気に入って頂けたら、正規登録することができます。
                マイページの「<span class="text-success">正規登録はこちら</span>」から、正規登録が行えます。
            </p>
            <img src="/img/help/account/05.png" alt="正規登録" class="img-thumbnail mb-3">
            <p>
                正規登録を行うと、お試し登録時に作成した小説作品やノートなどのデータをそのまま引き継ぎ、
                恒久的に貸し本棚の全ての機能をお使いいただけます。
            </p>
            <h5>Googleアカウントで登録</h5>
            <p>
                Googleのアカウントをお持ちの方は、そのアカウント連携によって正式登録することができます。
                メールアドレスやパスワードの設定の必要なく、ワンクリックで登録が完了します。
            </p>
            <p>
                ログインの際も、「連携ログイン」によってクリックひとつでログインすることができます。
            </p>
            <h5>メールアドレスで登録</h5>
            <p>
                メールアドレスで登録することもできます。
                登録されたメールアドレス宛に、登録確認メールが送信されますので、
                kashi-hondana.comからのメールが受信できるアドレスをお使いください。
            </p>
            <p>
                メールアドレスは「メールバックアップ機能」のために使われます。
                それ以外に宣伝や通知などのメールは送信されません。
            </p>
            <h4>登録削除</h4>
            <p>
                サイドメニューの「登録削除」を選択すると、お試しアカウントからログアウトし、
                アカウント情報は削除されます。
                お試しアカウントで追加した小説やノートも削除されますのでご注意ください。
            </p>
            <p>
                またお試し登録後、一定期間（48時間〜）アクセスの無い状態が継続すると、
                自動的にアカウント情報が削除されます。
                この保持期間は予告なく変更になることがあります。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "お試し登録 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>